export const ROLE = {
    InternalStandardUser: "internalStandardUser",
    InternalSuperAdminUser: "internalSuperAdminUser",
    ContractStandardUser: "contractStandardUser",
    FederalStandardUser: "federalStandardUser",
    FederalAuditUsers: "federalAuditUsers",
    ServicePartnerUser: "servicePartnerUser",
    AuditUser: "auditUser"
}